import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ActiveJson from "@/Config/Export/CreateNewJob/ActiveJson";
import FormGenerator from "@/Utils/FormGenerator/FormGenerator";
import { OutLinedButton } from "../Buttons/OutLinedButton";
import { BlackButton } from "../Buttons/FiledButton";
import { useUser } from "@/Context/UserContext";
import { useInActiveExporterMutation,useInActiveImporterMutation } from "@/redux/Active&InActive/ActiveSlice";
import SuccessDialog from "./SuccessDialog";
import { LuCheck } from "react-icons/lu";
import { BiSolidError } from "react-icons/bi";

// import FormGenerator from "./FormGenerator"; // adjust path

export default function ActiveDialog({ open, onClose,setShowSuccessDialog,setSuccessDialogConfig }) {
  const formRef = useRef(null);
  const { isRequiredFieldFilled,formData } = useUser();
  const [inActiveExporter] = useInActiveExporterMutation();
  const [inActiveImporter] = useInActiveImporterMutation();
  const { exporterId ,importerId} = useParams();
  const isEditMode = Boolean(exporterId || importerId);
const isActivation = Boolean(formData?.general?.exporterJobNumber || formData?.general?.importJobNumber);

  const handleProceed = async () => {
    if (!formRef.current?.submit) return;

    const formField = await formRef.current.submit();
    console.log("✅ formField:", formField);

    if (!formField || Object.keys(formField).length === 0) {
      return;
    }

    try {
      console.log(exporterId,importerId,"export and import id check")

      const { remarks } = formField;
      const payload = {
        id: exporterId || importerId,
        remarks: remarks,
      };
      console.log("✅ payload:", payload, formField);

      let activeRes;
      if(exporterId){
        activeRes = await inActiveExporter(payload).unwrap();
      }else{
        activeRes = await inActiveImporter(payload).unwrap();
      }
      console.log(activeRes,"activeRes")
      if (activeRes.statusCode === 200) {
        setSuccessDialogConfig({
          label: activeRes?.statusCode === 200 ? "Success" : "Failure",
          title: "",
          subtitle: (
            <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
              {activeRes?.statusCode === 200
                ? activeRes?.data?.message ||
                  activeRes?.message ||
                  "Deactivated successfully"
                : "Something went wrong"}
            </strong>
          ),
          buttonText: "OK",
          IconComponent: activeRes?.statusCode === 200 ? LuCheck : BiSolidError,
          status: activeRes?.statusCode === 200 ? "success" : "error",
        });
        
        setShowSuccessDialog(true);
      }
      onClose?.();

    } catch (error) {
      console.error("❌ Inactivate exporter failed:", error);
      setSuccessDialogConfig({
        label: "Failure",
        title: "",
        subtitle: (
          <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
            {error?.data?.message || "Something went wrong"}
          </strong>
        ),
        buttonText: "OK",
        status: "error",
        icon: BiSolidError,
      });

      setShowSuccessDialog(true);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        scroll="paper"
        sx={{
          "& .MuiDialog-paper": {
            overflow: "hidden", // ✅ disables dialog overflow
          },
        }}
      >
        {/* ---------- Header ---------- */}
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pr: 1,
          }}
        >
          {isActivation&& isEditMode  ? "Confirm Deactivation" : "Confirm Activation"}
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box>
            <FormGenerator
              compKey={isActivation&& isEditMode ? "Active" : "InActive"}
              ref={formRef}
              schema={ActiveJson}
              // onSubmit={handleFormSubmit}
            />
          </Box>
        </DialogContent>

        {/* ---------- Footer ---------- */}
        <DialogActions sx={{ px: 2, py: 0.8 }}>
          <OutLinedButton
            label="Ok"
            variant="bodySmallMedium"
            onClick={handleProceed}
            disabled={!isRequiredFieldFilled}
            sx={{
              width: "100px",
              borderRadius: 2,
              textTransform: "uppercase",
            }}
          />
          <BlackButton
            label="Cancel"
            variant="bodySmallMedium"
            onClick={onClose}
            sx={{
              width: "100px",
              mt: 1,
              color: "var(--gray-0)",
              borderRadius: 2,
              textTransform: "uppercase",
              backgroundColor: "var(--brand-600)",
            }}
          />
        </DialogActions>
      </Dialog>
      
    </>
  );
}
